import { InboxOutlined, Inventory2Outlined, OpenInNew } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'
import axios from 'axios'
import { Bin } from 'chezy-inventory-backend/bin/database/types/Bin'
import { useEffect, useState } from 'react'

import { BinPath } from '../../components/binPath'
import { getBaseURL } from '../../utils/getBaseURL'

export const BinResultRow = (props: { bin: Bin; onClick?: (bin: Bin) => void }) => {
  const isTote = !props.bin.parent_id
  const [binPath, setPath] = useState<Bin[]>([])

  useEffect(() => {
    if (props.bin.parent_id) {
      axios.get(`${getBaseURL()}/bin/${props.bin.id}/parents`).then(({ data }) => setPath(data))
    }
  }, [props.bin])

  return (
    <Box marginBottom="10px" marginTop="10px" display="flex" flexDirection="row" alignItems="center">
      {isTote ? (
        <Inventory2Outlined style={{ fontSize: 48, paddingRight: 20 }} />
      ) : (
        <InboxOutlined style={{ fontSize: 48, paddingRight: 20 }} />
      )}
      <Box flex="1">
        <Typography fontWeight={'bold'}>{props.bin.name}</Typography>
        {binPath.length > 1 && <BinPath binPath={binPath} />}
        {props.bin.description && <Typography style={{ marginLeft: '10px' }}>{props.bin.description}</Typography>}

        {props.bin.instructions && (
          <Typography style={{ marginLeft: '10px' }}>
            <span style={{ fontStyle: 'italic' }}>Instructions: </span>
            {props.bin.instructions}
          </Typography>
        )}
      </Box>
      <Box style={{ minWidth: '50px' }}>
        <IconButton onClick={() => props.onClick?.(props.bin)}>
          <OpenInNew />
        </IconButton>
      </Box>
    </Box>
  )
}
